import xhr from "xhr";
import api from "./api";
import wNumnb from 'wnumb';

class configInformationLoader {
    initialize() {
        let isCustomConfig = document.getElementById('configId') ? document.getElementById('configId').value : null,
            isFixedVehicle = document.getElementById('vehicleModelCode') ? document.getElementById('vehicleModelCode').value : null;
        if (!isCustomConfig) {
            // récupération du configId sur la page de confirm
            isCustomConfig = document.querySelector('main[data-configId]') ? document.querySelector('main[data-configId]').dataset.configid : null;
        }
        if (isCustomConfig || isFixedVehicle) {
            const vehicule_id = document.querySelector("main").getAttribute("data-id");
            const fixedVehicleOptions = document.getElementById('vehicleModelOptions') ? document.getElementById('vehicleModelOptions').value : null;
            xhr(
                {
                    method: "GET",
                    uri: api().bmw + configInformationsUrl + '/' + vehicule_id + '/' + (isCustomConfig ? isCustomConfig : '')  + '?' + (fixedVehicleOptions ? '&vehicleOptions=' + fixedVehicleOptions : '')  + (isFixedVehicle ? '&vehicleModelCode=' + isFixedVehicle : '')
                },
                (err, resp, body) => {
                    let data = null
                    try {
                        data = JSON.parse(body)
                    } catch (e) {
                        return;
                    }
                    if (data) {
                        if (data.fueltype && document.getElementById('carInformationsFuelType')) {
                            document.getElementById('carInformationsFuelType').innerText = data.fueltype;
                        }
                        if (data.transmission && document.getElementById('carInformationsList')) {
                            var infosContainer = document.getElementById('carInformationsList');
                            infosContainer.innerHTML = '<li>' + data.transmission + '</li>';
                        }

                        if (data.price && document.getElementById('vehicleConfigPricing')) {
                            var Format = wNumnb({decimals: 0, thousand: ' '})
                            document.getElementById('vehicleConfigPricing').innerText = Format.to(data.price);
                            if(document.getElementById('vehicleConfigPricingMobile')){
                                 document.getElementById('vehicleConfigPricingMobile').innerText = Format.to(data.price);
                            }
                        }
                        if (typeof digitalData !== 'undefined') {
                            if (data.color) {
                                digitalData.product.color = data.color;
                            }
                            if (data.fueltypeCode) {
                                digitalData.product.fuelType = data.fueltypeCode;
                            }
                            if (data.transmissionCode) {
                                digitalData.product.gearing = data.transmissionCode;
                            }
                            if (data.modelCodeAG) {
                                digitalData.product.modelCodeAG = digitalData.product.modelCode = data.modelCodeAG;
                            }
                            if (data.motorization) {
                                digitalData.product.motorization = data.motorization;
                            }
                            // show updated datalayer
                            //console.log('updated datalayer after loading config infos : ');
                            //console.log(digitalData);
                        }

                        if (data.hasOwnProperty('attr')) {
                            for (const key in data.attr) {
                                let nodes = document.querySelectorAll('*[data-car-attr="' + key + '"]');
                                nodes.forEach(node => {
                                    if (data.attr[key] === false) {
                                        node.classList.add('hidden');
                                    } else {
                                        node.classList.remove('hidden');
                                        node.querySelector('*[data-car-attr-value]').innerHTML = data.attr[key];
                                    }
                                })
                            }
                        }

                        // show all loaded elements
                        let loadedElements = document.querySelectorAll('.loadingConfigId');
                        if (loadedElements) {
                            loadedElements.forEach(item => {
                                item.classList.remove('loadingConfigId');
                            });
                        }
                    }
                }
            );
        }
    }
}

export default configInformationLoader;
